// Site Profile Action Types
export const FETCH_SITE_PROFILE_REQUEST = 'FETCH_SITE_PROFILE_REQUEST';
export const FETCH_SITE_PROFILE_SUCCESS = 'FETCH_SITE_PROFILE_SUCCESS';
export const FETCH_SITE_PROFILE_FAILURE = 'FETCH_SITE_PROFILE_FAILURE';

// Site Coverage Hours Action Types
export const FETCH_SITE_COVERAGE_HOURS_REQUEST = 'FETCH_SITE_COVERAGE_HOURS_REQUEST';
export const FETCH_SITE_COVERAGE_HOURS_SUCCESS = 'FETCH_SITE_COVERAGE_HOURS_SUCCESS';
export const FETCH_SITE_COVERAGE_HOURS_FAILURE = 'FETCH_SITE_COVERAGE_HOURS_FAILURE';

// Site Associated Radiologists Action Types
export const FETCH_SITE_ASSOCIATED_RADS_REQUEST = 'FETCH_SITE_ASSOCIATED_RADS_REQUEST';
export const FETCH_SITE_ASSOCIATED_RADS_SUCCESS = 'FETCH_SITE_ASSOCIATED_RADS_SUCCESS';
export const FETCH_SITE_ASSOCIATED_RADS_FAILURE = 'FETCH_SITE_ASSOCIATED_RADS_FAILURE';

// Site Calendar Demand Action Types
export const FETCH_SITE_CALENDAR_DEMAND_REQUEST = 'FETCH_SITE_CALENDAR_DEMAND_REQUEST';
export const FETCH_SITE_CALENDAR_DEMAND_SUCCESS = 'FETCH_SITE_CALENDAR_DEMAND_SUCCESS';
export const FETCH_SITE_CALENDAR_DEMAND_FAILURE = 'FETCH_SITE_CALENDAR_DEMAND_FAILURE';

// Site Calendar Demand By Date Action Types
export const FETCH_SITE_CALENDAR_DEMAND_BY_DATE_REQUEST = 'FETCH_SITE_CALENDAR_DEMAND_BY_DATE_REQUEST';
export const FETCH_SITE_CALENDAR_DEMAND_BY_DATE_SUCCESS = 'FETCH_SITE_CALENDAR_DEMAND_BY_DATE_SUCCESS';
export const FETCH_SITE_CALENDAR_DEMAND_BY_DATE_FAILURE = 'FETCH_SITE_CALENDAR_DEMAND_BY_DATE_FAILURE';

// Site RADS Demand Schedule Action Types
export const FETCH_SITE_RADS_DEMAND_SCHEDULE_REQUEST = 'FETCH_SITE_RADS_DEMAND_SCHEDULE_REQUEST';
export const FETCH_SITE_RADS_DEMAND_SCHEDULE_SUCCESS = 'FETCH_SITE_RADS_DEMAND_SCHEDULE_SUCCESS';
export const FETCH_SITE_RADS_DEMAND_SCHEDULE_FAILURE = 'FETCH_SITE_RADS_DEMAND_SCHEDULE_FAILURE';

// Site Associated RAD Metrics Action Types  
export const FETCH_SITE_ASSOCIATED_RAD_METRICS_REQUEST = 'FETCH_SITE_ASSOCIATED_RAD_METRICS_REQUEST';
export const FETCH_SITE_ASSOCIATED_RAD_METRICS_SUCCESS = 'FETCH_SITE_ASSOCIATED_RAD_METRICS_SUCCESS';
export const FETCH_SITE_ASSOCIATED_RAD_METRICS_FAILURE = 'FETCH_SITE_ASSOCIATED_RAD_METRICS_FAILURE';

// Site RAD Metrics Dropdown Action Types
export const FETCH_SITE_RAD_METRICS_DROPDOWN_REQUEST = 'FETCH_SITE_RAD_METRICS_DROPDOWN_REQUEST';
export const FETCH_SITE_RAD_METRICS_DROPDOWN_SUCCESS = 'FETCH_SITE_RAD_METRICS_DROPDOWN_SUCCESS';
export const FETCH_SITE_RAD_METRICS_DROPDOWN_FAILURE = 'FETCH_SITE_RAD_METRICS_DROPDOWN_FAILURE';

// Export Site Associated RAD Metrics Action Types
export const EXPORT_SITE_ASSOCIATED_RAD_METRICS_REQUEST = 'EXPORT_SITE_ASSOCIATED_RAD_METRICS_REQUEST';
export const EXPORT_SITE_ASSOCIATED_RAD_METRICS_SUCCESS = 'EXPORT_SITE_ASSOCIATED_RAD_METRICS_SUCCESS';
export const EXPORT_SITE_ASSOCIATED_RAD_METRICS_FAILURE = 'EXPORT_SITE_ASSOCIATED_RAD_METRICS_FAILURE';

// Site Matrix Child Tables Action Types
export const FETCH_SITE_MATRIX_CHILD_TABLES_REQUEST = 'FETCH_SITE_MATRIX_CHILD_TABLES_REQUEST';
export const FETCH_SITE_MATRIX_CHILD_TABLES_SUCCESS = 'FETCH_SITE_MATRIX_CHILD_TABLES_SUCCESS';
export const FETCH_SITE_MATRIX_CHILD_TABLES_FAILURE = 'FETCH_SITE_MATRIX_CHILD_TABLES_FAILURE';

// Site Profile Demand By Hours Chart Action Types
export const FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_REQUEST = 'FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_REQUEST';
export const FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_SUCCESS = 'FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_SUCCESS';
export const FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_FAILURE = 'FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_FAILURE';

// Site Profile Volume By Priority Chart Action Types
export const FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_REQUEST = 'FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_REQUEST';
export const FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_SUCCESS = 'FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_SUCCESS';
export const FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_FAILURE = 'FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_FAILURE';

// Site Profile Volume By Modality Chart Action Types
export const FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_REQUEST = 'FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_REQUEST';
export const FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_SUCCESS = 'FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_SUCCESS';
export const FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_FAILURE = 'FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_FAILURE';

// Associate RAD to Site Action Types
export const ASSOCIATE_RAD_TO_SITE_REQUEST = 'ASSOCIATE_RAD_TO_SITE_REQUEST';
export const ASSOCIATE_RAD_TO_SITE_SUCCESS = 'ASSOCIATE_RAD_TO_SITE_SUCCESS';
export const ASSOCIATE_RAD_TO_SITE_FAILURE = 'ASSOCIATE_RAD_TO_SITE_FAILURE';

// Disassociate RAD from Site Action Types
export const DISASSOCIATE_RAD_FROM_SITE_REQUEST = 'DISASSOCIATE_RAD_FROM_SITE_REQUEST';
export const DISASSOCIATE_RAD_FROM_SITE_SUCCESS = 'DISASSOCIATE_RAD_FROM_SITE_SUCCESS';
export const DISASSOCIATE_RAD_FROM_SITE_FAILURE = 'DISASSOCIATE_RAD_FROM_SITE_FAILURE';

// RADs Not Associated To Site (dropdown) Action Types
export const FETCH_RADS_NOT_ASSOCIATED_TO_SITE_REQUEST = 'FETCH_RADS_NOT_ASSOCIATED_TO_SITE_REQUEST';
export const FETCH_RADS_NOT_ASSOCIATED_TO_SITE_SUCCESS = 'FETCH_RADS_NOT_ASSOCIATED_TO_SITE_SUCCESS';
export const FETCH_RADS_NOT_ASSOCIATED_TO_SITE_FAILURE = 'FETCH_RADS_NOT_ASSOCIATED_TO_SITE_FAILURE';

// Site Profile Metrics Dropdown Action Types
export const FETCH_SITE_PROFILE_METRICS_DROPDOWN_REQUEST = 'FETCH_SITE_PROFILE_METRICS_DROPDOWN_REQUEST';
export const FETCH_SITE_PROFILE_METRICS_DROPDOWN_SUCCESS = 'FETCH_SITE_PROFILE_METRICS_DROPDOWN_SUCCESS';
export const FETCH_SITE_PROFILE_METRICS_DROPDOWN_FAILURE = 'FETCH_SITE_PROFILE_METRICS_DROPDOWN_FAILURE';

// Site Profile Demand By Hours Chart Details (Filtered) Action Types
export const FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_REQUEST = 'FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_REQUEST';
export const FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_SUCCESS = 'FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_SUCCESS';
export const FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_FAILURE = 'FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_FAILURE';

// Site Profile Volume By Modality Chart Details (Filtered) Action Types
export const FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_REQUEST = 'FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_REQUEST';
export const FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_SUCCESS = 'FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_SUCCESS';
export const FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_FAILURE = 'FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_FAILURE';

// Site Profile Volume By Priority Chart Details (Filtered) Action Types
export const FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_REQUEST = 'FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_REQUEST';
export const FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_SUCCESS = 'FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_SUCCESS';
export const FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_FAILURE = 'FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_FAILURE';

// Site Rad Assignment Notes Action Types
export const FETCH_SITE_RAD_NOTES_REQUEST = 'FETCH_SITE_RAD_NOTES_REQUEST';
export const FETCH_SITE_RAD_NOTES_SUCCESS = 'FETCH_SITE_RAD_NOTES_SUCCESS';
export const FETCH_SITE_RAD_NOTES_FAILURE = 'FETCH_SITE_RAD_NOTES_FAILURE';

export const FETCH_SITE_RAD_ALL_NOTES_REQUEST = 'FETCH_SITE_RAD_ALL_NOTES_REQUEST';
export const FETCH_SITE_RAD_ALL_NOTES_SUCCESS = 'FETCH_SITE_RAD_ALL_NOTES_SUCCESS';
export const FETCH_SITE_RAD_ALL_NOTES_FAILURE = 'FETCH_SITE_RAD_ALL_NOTES_FAILURE';

export const ADD_SITE_RAD_NOTE_REQUEST = 'ADD_SITE_RAD_NOTE_REQUEST';
export const ADD_SITE_RAD_NOTE_SUCCESS = 'ADD_SITE_RAD_NOTE_SUCCESS';
export const ADD_SITE_RAD_NOTE_FAILURE = 'ADD_SITE_RAD_NOTE_FAILURE';

export const CLEAR_SITE_RAD_NOTES = 'CLEAR_SITE_RAD_NOTES';
export const CLEAR_SITE_RAD_ALL_NOTES = 'CLEAR_SITE_RAD_ALL_NOTES';
export const RESET_ADD_SITE_RAD_NOTE_SUCCESS = 'RESET_ADD_SITE_RAD_NOTE_SUCCESS';


export const FETCH_SITE_WORKLISTS_REQUEST = 'FETCH_SITE_WORKLISTS_REQUEST';
export const FETCH_SITE_WORKLISTS_SUCCESS = 'FETCH_SITE_WORKLISTS_SUCCESS';
export const FETCH_SITE_WORKLISTS_FAILURE = 'FETCH_SITE_WORKLISTS_FAILURE';
export const RESET_SITE_WORKLIST_CONTEXT = 'RESET_SITE_WORKLIST_CONTEXT';
export const RESET_SITE_SCHEDULE_CONTEXT = 'RESET_SITE_SCHEDULE_CONTEXT';
export const RESET_SITE_CALENDAR_CONTEXT = 'RESET_SITE_CALENDAR_CONTEXT';
